import { Component, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Location, CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AppButton } from '../../shared/components/app-button/app-button';
import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule, AppButton],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './not-found.html',
  styleUrls: ['./not-found.css']
})
export class NotFoundComponent {
  private nav = inject(NavigationService);
  private router = inject(Router);

  goBack() {
    this.nav.goBack();
  }

  goToLogin = () => {
    this.router.navigate(['/auth/login']);
  };
}
